import { LookupValues } from '../types';

export const PROXIED_ORIGINS = {
    // covers zillowhomeloans.com, dev.zillowhomeloans.net, and staging.zillowhomeloans.net
    ZILLOW_HOME_LOANS: 'zillowhomeloans',
    // covers qa.zillow.com, zillow.com. The period is important to distinguish it from zillow-dev-k8s or zillow-test-k8s
    ZILLOW: 'zillow.',
    LOCALHOST: 'localhost',
    ZGCP: 'zhl-mortgage-application-center-web-',
} as const;

export type ProxyOrigin = LookupValues<typeof PROXIED_ORIGINS>;

export const PROXY_ORIGIN_TO_PREFIX: Record<ProxyOrigin, string> = {
    [PROXIED_ORIGINS.LOCALHOST]: '/mortgage',
    [PROXIED_ORIGINS.ZILLOW_HOME_LOANS]: '/mortgage',
    [PROXIED_ORIGINS.ZGCP]: '/mortgage',
    [PROXIED_ORIGINS.ZILLOW]: '/homeloans/mortgage',
};

export const getProxyOrigin = (origin: string): ProxyOrigin | null => {
    // ordering is important because zillow is a substring of zillowhomeloans
    if (origin.includes(PROXIED_ORIGINS.ZILLOW_HOME_LOANS)) {
        return PROXIED_ORIGINS.ZILLOW_HOME_LOANS;
    }

    if (origin.includes(PROXIED_ORIGINS.ZILLOW)) {
        return PROXIED_ORIGINS.ZILLOW;
    }

    if (origin.includes(PROXIED_ORIGINS.LOCALHOST)) {
        return PROXIED_ORIGINS.LOCALHOST;
    }
    if (origin.includes(PROXIED_ORIGINS.ZGCP)) {
        return PROXIED_ORIGINS.ZGCP;
    }

    return null;
};
